import api from './api';

// Defina os tipos
export interface User {
    id: string;
    userId: string;
    name: string;
    email: string;
    phone?: string;
    status: 'pending' | 'active' | 'blocked';
}

export interface CreateUserData {
    name: string;
    email: string;
    password: string;
    phone?: string;
}

export const userService = {
    // Buscar um usuário pelo ID
    getUser: async (id: string): Promise<User> => {
        const response = await api.get(`/users/${id}`);
        return response.data;
    },

    // Criar um novo usuário
    createUser: async (userData: CreateUserData): Promise<User> => {
        const response = await api.post('/api/auth/signup', userData);
        return response.data;
    },

    // Atualizar um usuário existente
    updateUser: async (id: string, userData: Partial<User>): Promise<User> => {
        const response = await api.put(`/users/${id}`, userData);
        return response.data;
    }
};